export default __webpack_public_path__ + "static/media/icon_all-sections.e37943af.svg";